export class DataMap {
  constructor(context) {
    this.context = context;
  }

  get element() {
    return this.context.element;
  }

  get identifier() {
    return this.context.identifier;
  }

  get state() {
    return this.context.state;
  }

  get(key) {
    return this.element.getAttribute(this._getFormattedKey(key));
  }

  set(key, value) {
    this.element.setAttribute(this._getFormattedKey(key), value);

    if (!this.state.hasKey(key)) {
      this.state.addKey(key, value);
    }

    this.state[key] = value;
    return this.get(key);
  }

  has(key) {
    return this.element.hasAttribute(this._getFormattedKey(key));
  }

  delete(key) {
    if (this.has(key)) {
      this.element.removeAttribute(this._getFormattedKey(key));
      return true;
    }

    return false;
  }

  _getFormattedKey(key) {
    return "data-".concat(this.identifier, "-").concat(dasherize(key));
  }

}

function dasherize(value) {
  return value.replace(/([A-Z])/g, (_, char) => "-".concat(char.toLowerCase()));
}